import * as React from 'react';
import Form, { FormComponentProps } from 'antd/lib/form';
import { Row, Col, DatePicker, Button, Tooltip, Icon, Popover } from 'antd';
import ConfigUtility from 'Core/ConfigUtility';
import FormControl from 'components/Forms/FormControl';
import moment, { Moment } from 'moment';
import { ButtonSize } from 'antd/lib/button';
import Utility from 'Core/Utility';
import { DateInJamaicaLabel } from 'components/Forms/DateInJamaicaLabel';
import ShowIfTrue from 'components/Forms/ShowIfTrue';

export interface Props extends FormComponentProps {
  children?: React.ReactNode;
  currentDate?: Moment;
  UpdatedDate: (date: Moment) => void;
  buttonText?: string;
  buttonSize?: ButtonSize;

}

export interface State {
  showPopup?: boolean;
  selectedDate?: Moment
}

export class CartItemChangeDateFormWithoutForms extends React.Component<Props, State> {
  config = ConfigUtility.getSync();
  static defaultProps: Props = {
    buttonText: "Change Pickup Date ",
    UpdatedDate: () => { },
    form: {} as any,
    buttonSize: "small",
  }

  popoverRef: React.Ref<Popover>;

  constructor(props: Props) {
    super(props);

    this.state = {};
    this.popoverRef = React.createRef<Popover>();
  }


  onSubmit(event: React.FormEvent) {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((error, values: any) => {
      if (!error) {
        let fullDate = values.pickupDate as Moment;
        fullDate = fullDate.clone().set("hour", moment().hour());
        let localizedDate: Moment | undefined = undefined;

        if (fullDate.utcOffset() != this.config!.Display.StandardTimeZone * 60) {
          localizedDate = fullDate.clone().utcOffset(this.config?.Display.StandardTimeZone ?? -5);
        } else {
          localizedDate = fullDate.clone();
        }

        this.props.UpdatedDate(localizedDate);
        ((this.popoverRef as any).current.getPopupDomNode() as HTMLDivElement).innerHTML = "";
      }
    });

  }

  renderPopoverTitle() {
    return (
      <>
        <div onClick={e => e.stopPropagation()}>
          Change Pickup Date
          <Tooltip title={<>You can change the pickup date for this item. This may incur additional charges.<ShowIfTrue condition={(moment().utcOffset() / 60) != this.config?.Display.StandardTimeZone} >Your Time Zone places you outside of Jamaica. Pickup Date selected will be converted to the Jamaican equivalent.</ShowIfTrue></>}>
            <Icon style={{ marginLeft: "5px" }} type="info-circle" />
          </Tooltip>
        </div>
      </>
    );
  }

  render() {
    return (
      <Popover ref={this.popoverRef}
        destroyTooltipOnHide={true}
        title={this.renderPopoverTitle()}
        trigger="click"
        content={this.renderForm()}>
        <Button style={{ marginLeft: '5px' }} onClick={e => { this.setState({ showPopup: true }); e.stopPropagation(); }} size={this.props.buttonSize}>
          {this.props.buttonText}
        </Button>
      </Popover>
    );
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;
    const config = ConfigUtility.getSync();
    const dateFormat = config?.Display?.DateFormat;

    return (
      <Form onClick={(e) => e.stopPropagation()} onSubmit={(e) => !(e.stopPropagation() != undefined) && this.onSubmit(e)} layout="inline">
        <Row>
          <Col>
            <ShowIfTrue condition={(moment().utcOffset() / 60) != this.config?.Display.StandardTimeZone} >Your Time Zone places you outside of Jamaica. Pickup Date selected will be converted to the Jamaican equivalent.</ShowIfTrue>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormControl
              getFieldDecorator={getFieldDecorator}
              initialValue={this.props.currentDate}
              rules={[{ required: true, message: 'Please enter a Date' }]}
              help={<DateInJamaicaLabel date={this.state.selectedDate} />}
              name="pickupDate">
              <DatePicker
                onChange={(date) => this.setState({ selectedDate: date ?? undefined })}
                className="datePicker"
                format={dateFormat}
                placeholder="Select new date"
                disabledDate={Utility.getDisableBOLDates()}
              />
            </FormControl>

          </Col>
          <Col><Button htmlType="submit">Update</Button></Col>
        </Row>
      </Form>
    );
  }
}

const CartItemChangeDateForm = Form.create<Props>({
  name: "CartItemChangeDateForm"
})(CartItemChangeDateFormWithoutForms);

export default CartItemChangeDateForm;